export default {
  title: {
    addCandidate: 'Add Candidate',
    editCandidate: 'Edit Candidate',
    step: {
      UPLOAD_RESUME: 'Upload Resume',
      BASE_INFO: 'Basic Information',
      DUPLICATE_CANDIDATE: 'Duplicate Candidate',
      EDUCATION: 'Education',
      WORK_EXPERIENCE: 'Work Experience',
      LANGUAGE: 'Language(s)',
      ADDITIONAL_INFO: 'Additional Info',
      DESCRIPTION: 'Recruiter Description',
      PRESCREEN_QUESTIONNAIRE: 'Applicant Prescreen Section Questionnaire',
      JOB_QUESTIONNAIRE: 'Applicant Questionnaire',
      INVITE_QUESTIONNAIRE: 'Specific Questions',
      HR_QUESTIONNAIRE: 'Recruiter Screening',
      ONBOARDING_QUESTIONNAIRE: 'Onboarding Questionnaire Responses',
      SUBMIT_REFERRAL: 'Submit / Upload Resume'
    },
    importResume: 'Import Resume',
    duplicateTitle: 'Duplicate Candidates',
    history: 'Batch Upload History',
    uploader: 'Batch Upload',
    baseInfo: 'Basic Info',
    education: 'Education',
    additionalInfo: 'Additional Info',
    language: 'Language',
    aiInterview: 'AI Interview',
    consent: 'Consent',
    workExperience: 'Work Experience',
    partTimeExperience: 'Intern / Part Time Experience',
    comment: 'Comments',
    appliedJobHistory: 'Applied Job History',
    candidateActivity: 'Candidate Activity',
    smartTags: 'SMART TAGS',
    manualTags: 'MANUAL TAGS',
    interviewManagement: 'Interview Management',
    interviewOverallRating: 'Interview Overall Rating',
    interviewRatingForm: 'Interview Rating Form',
    hiringManagerRating: 'Hiring Manager(s) Rating',
    hrQuestionnaire: 'Recruiter Screening',
    jobQuestionnaireResponse: 'Applicant Questionnaire',
    prescreenQuestionnaire: 'Job Prescreen Questionnaire Responses',
    specificQuestion: 'Specific Questions',
    assessmentScore: 'Assessment Scores',
    detailResume: 'Detail Resume',
    addComment: 'Add Comment',
    onboardingQuestionnaire: 'Onboarding Questionnaire',
    contact: 'Contact',
    groupRecord: 'Group History',
    preferenceQuestion: 'Preference Survey Responses',
    notification: 'Job Alert Preferences',
    inviteConsentTitle: 'Consent Collection',
    aiResumeSummarizer: 'AI Resume Summary',
    aiResumeMatchScore: 'AI Fit',
    aiResumeMatchSummary: 'AI Analysis',
    aiResumeSummaryContent: 'AI Resume Summary',
    aiResumeFitScore: 'AI Fit Score',
    rateManagement: 'Profile Rating Management',
    offerLetterSelectTemplate: 'Select Offer Template',
    sendOfferLetter: 'Send Offer',
    offerRecord: 'Offer Record',
    confirmUpdateSelfResumeTitle: 'Does it update its own resume ?',
    similarCandidate: 'AI Talent Twins'
  },
  tabMenu: {
    RESUME: 'Resume',
    REFERRAL_CHAIN: 'Referral Chain',
    OPEN_QUESTION: 'Screen',
    ASSESSMENT: 'Assessment',
    INTERVIEW: 'Interview',
    ONBOARDING: 'Onboarding',
    ACTIVITY_TRACKER: 'Activity',
    TAG: 'Tags',
    SATISFACTION: 'Satisfaction',
    PORTAL: 'Experience Portal(s)',
    OFFER: 'Offer',
    JOB_APPLICATION: 'Application Form'
  },
  label: {
    professionalMemberShip: 'Professional Memberships',
    awards: 'Awards',
    hobbies: 'Hobbies',
    stepName: {
      UPLOAD_RESUME: 'Upload Resume',
      BASE_INFO: 'Basic Information',
      MINI_BASE_INFO: 'Resume',
      DUPLICATE_CANDIDATE: 'Duplicate Candidate',
      EDUCATION: 'Education',
      WORK_EXPERIENCE: 'Work Experience',
      LANGUAGE: 'Language(s)',
      ADDITIONAL_INFO: 'Additional Info',
      DESCRIPTION: 'Recruiter Description',
      PRESCREEN_QUESTIONNAIRE: 'Applicant Prescreen Section Questionnaire',
      JOB_QUESTIONNAIRE: 'Questions',
      INVITE_QUESTIONNAIRE: 'Additional Questions',
      HR_QUESTIONNAIRE: 'Recruiter Screening',
      ONBOARDING_QUESTIONNAIRE: 'Onboarding Questionnaire Responses',
      SUBMIT_REFERRAL: 'Submit / Upload Resume',
      RESUME_INFO: 'Preview'
    },
    addCandidateTo: 'Add Candidate To',
    selectCandidate: 'Please select a job',
    emailAddress: 'Email Address',
    firstName: 'First Name',
    lastName: 'Last Name',
    candidateId: 'Candidate ID',
    salutation: 'Salutation',
    employeeId: 'Employee ID',
    Mr: 'Mr.',
    Mrs: 'Mrs',
    Ms: 'Ms.',
    gender: 'Gender',
    birthday: 'Date of Birth',
    photo: 'Photo',
    homeLocation: 'Home Location',
    country: 'Hukou Country / Region',
    province: 'Hukou Province',
    city: 'Hukou City',
    currentLocation: 'Current Location',
    currentCountry: 'Country / Region',
    currentProvince: 'Province / State',
    currentCity: 'City / Town',
    address: 'Address',
    otherAddressIfHave: 'Address(Other - if have)',
    otherAddress: 'Other Address',
    mobile: 'Mobile',
    secondPhone: 'Second Phone',
    chatId: 'Chat ID',
    socialNetwork: 'Social Network(s)',
    personalStatement: 'Personal Statement',
    expectedSalary: 'Expected Salary',
    expectedAddress: 'Expected Work Location',
    show: 'Show',
    notShow: 'Hidden',
    source: 'Source Name',
    code: 'Source Tag/Detail',
    comment: 'Comment',
    isPrivate: 'Private',
    interviewerCanView: 'Interviewer',
    myComment: 'My Comments',
    tag: {
      smart: 'Smart Tags',
      manual: 'Candidate Tags'
    },
    tillNow: 'Now',
    idNumber: 'ID Number',
    onboardDate: 'Estimated Onboard Date',
    hiredDate: 'Hired Date',
    required: 'required',
    agree: 'Agree',
    question: 'Q: ',
    onlyTalentPool: 'Add To Talent Pool Only',
    duplicateCandidate: {
      id: 'ID',
      name: 'Name',
      phone: 'Phone',
      email: 'Email'
    },
    educationLevel: 'Education Level',
    major: 'Major',
    degreeAndMajor: 'Degree and Major',
    notMajorInfo: 'Major not in list?',
    majorInput: 'if not list, input here',
    startAndEndDate: 'Start And End Times',
    endDateVerify: 'End dates should be later than start dates.',
    startDate: 'Start Date',
    endDate: 'End Date',
    school: 'School',
    notSchool: 'School not in list?',
    academicRating: 'Academic Rating',
    gpa: 'GPA',
    gpaInfo: 'Please input your Grade Point Average (GPA)',
    summary: 'Summary',
    summaryInfo: 'Use this section to share a little more about your education. What were your accomplishments? What were your favorite subjects and why? Did you take part in any special programs? Were you a member of a club or association? Did you have any responsibilities?',
    language: 'Language',
    level: 'Level',
    certification: 'Certification',
    score: 'Score',
    fileName: 'File Name',
    startTime: 'Create Date',
    finishTime: 'Finish Date',
    status: 'Status',
    browserFiles: 'Browse',
    reupload: 'Reupload',
    jobTitle: 'Job Title',
    companyName: 'Company Name',
    industry: 'Industry',
    location: 'Location',
    workCountry: 'Country / Region',
    countryInfo: 'Simplified characters or English characters only',
    workProvince: 'Province / State',
    workCity: 'City / Town',
    endDateInfo: 'Leave blank if currently working here',
    salary: 'Salary',
    salaryInfo: 'monthly after taxes in RMB',
    jobFamily: 'Job Family',
    description: 'Description',
    descriptionInfo: 'Use this section to share a little more about your work experience. What were your responsibilities? What did you accomplish? What did you learn? How did you develop yourself?',
    applicationChannel: 'Application Channel',
    jobApplicationPlat: 'Application Platform',
    referrer: 'Referred By',
    referralChain: 'Referral Chain',
    date: 'Date ',
    consentStatus: 'Consent Status',
    consentUpdatedTime: 'Consent Date Time',
    consentInfo: 'Consent Policy',
    job: 'Job',
    candidateStatus: 'Status',
    cause: 'Cause',
    comments: 'Comment',
    activitySource: 'Source Name',
    activity: 'Activities',
    recruiter: 'Recruiter',
    hiringManagerNames: 'Hiring Manager(s)',
    candidateNames: 'Candidate(s)',
    candidateName: 'Candidate Name',
    action: 'Action',
    ratingCompletion: 'Completion Rate',
    ratingCompletionNumber: 'Completion Rate: {completion}%',
    hmRatingResult: 'Rating Result',
    hmInterviewResult: 'Interview Result',
    questionNumber: 'Question {number}:',
    weighting: 'Weighting {value}%',
    scale: 'Response Scale',
    overall: 'Overall',
    interview: 'Interview',
    interviewSequence: 'Interview {number}',
    rating: 'Rating',
    ratingSequence: 'Rating {number}',
    hmEvaluationQuestionType: {
      rating: 'Rating',
      text: 'Text',
      singleSelect: 'Single-select',
      multiSelect: 'Multi-select',
      date: 'Date'
    },
    PENDING: 'Rating Pending',
    FINISHED: 'Rating Finished',
    SCHEDULED: 'Scheduled',
    CANCELED: 'Canceled',
    CANCELED_BY_ORGANIZER: 'Canceled - Organizer',
    PENDING_CANDIDATE_SELECT_TIME: 'Pending - Candidate select interview time',
    PENDING_HM_SELECT_TIME: 'Pending - Interviewer to select interview time',
    PARTIAL_CANCELED_BY_INTERVIEWER: 'Part Interviewer Canceled',
    RESCHEDULING_BY_CANDIDATE: 'Rescheduling - By candidate',
    RESCHEDULING_BY_INTERVIEWER: 'Rescheduling - By interviewer',
    CANCELED_BY_CANDIDATE: 'Canceled - Candidate',
    CANCELED_BY_INTERVIEWER: 'Canceled - Interviewer',
    PENDING_GENERATE_TEAMS_URL: 'Pending - Generate teams URL',
    PENDING_GENERATE_TEAMS_EVENT: 'Pending - Generate Teams event',
    PARTIALLY_RATED: 'Partially Rated',
    RECOMMENDED: 'Recommended',
    RATE_PENDING: 'Pending',
    NOT_RECOMMENDED: 'Not Recommended',
    NO_RECOMMENDATION: 'No Recommendation',
    SPLIT_DECISION: 'Split Decision',
    NOT_YET_RATE: 'Rating Pending',
    video: 'Video',
    note: 'Note',
    questionnaireQuestion: 'Question',
    answer: 'Answer',
    parentQuestion: 'Parent question',
    triggerOption: 'Trigger option',
    tree: {
      selected: 'Selected',
      answered: 'Answered'
    },
    age: 'Age',
    appliedDate: 'Applied Date',
    appliedDays: '{duration} days old',
    appliedHours: '{duration} hours old',
    appliedTimes: '{times}st application',
    appliedJob: 'Applied',
    resumeFit: 'Average Total Fit',
    cultureFit: 'Culture Fit',
    personalityFit: 'Personality Fit',
    problemSolvingFit: 'Problem Solving Fit',
    now: 'Now',
    dates: {
      years: '{num} years',
      months: '{num} months',
      days: '{num} days',
      year: '{num} year',
      month: '{num} month',
      day: '{num} day'
    },
    validationInfo: 'Validation Info',
    employeeStatus: 'Status',
    employee: 'Employee',
    nonEmployee: 'Non-Employee',
    mobileId: 'Mobile ID',
    name: 'Name',
    email: 'Email',
    referralReason: 'Referral Reason',
    referralStatusPending: 'Pending',
    referralStatusApproved: 'Approved',
    referralStatusRejected: 'Rejected',
    notUploadedByHr: 'Video was not uploaded by hr',
    videoNotUploaded: 'Video was not uploaded',
    candidate: 'Candidate',
    noMobile: 'No Mobile',
    noEmail: 'No Email',
    invitationTime: 'Invitation Time',
    applicationFormReactivateReason: 'Reinvitation Reason: ',
    interviewDate: 'Interview Time',
    interviewTime: '{startTime} - {endTime}',
    interviewDay: '{weekday}, {month} {day}, {year}',
    interviewStatus: 'Interview Status',
    agreement: {
      agree: 'Agreed',
      disAgree: 'Disagreed'
    },
    operation: 'Operation',
    fromGroup: 'From',
    toGroup: 'To',
    notificationFrequency: 'Job Alert Sending Frequency',
    notificationChannel: 'Job Alert Notification Preferences',
    notification: {
      never: 'Off',
      weekly: 'Weekly',
      monthly: 'Monthly',
      email: 'Email',
      wechat: 'WeChat',
      both: 'WeChat & Email'
    },
    highestDegree: 'Highest Degree',
    updateMobilePhone: 'Update Mobile',
    inviteSuccess: 'Invite Success',
    resumePath: 'View Original Resume',
    emailSubject: 'Title',
    yearsOld: '{age} y/o',
    workExperienceFit: 'Work Experience Fit (BETA)',
    consentVersion: 'Policy Version',
    consentVersionCode: 'Version',
    entity: 'Entity',
    upcomingInterview: 'Upcoming Interview',
    interviewResultsPending: 'Interview Results Pending',
    completedInterviews: 'Completed Interviews',
    asOfCurrent: 'Current as of {currentTime}',
    inviteCandidateToInterview: 'Invite Candidate To Interview',
    today: 'Today',
    switchMiniResume: 'Basic Info',
    switchFullResume: 'Full Resume',
    consentLinkTitle: 'Copy the consent URL to send to your candidate to collect consent',
    consentLinkLabel: 'URL',
    consentQrCodeTile: 'Generate a consent QR-code to send to your candidate to collect consent',
    consentQrCodeLabel: 'QR-code',
    consentSendTitle: 'Do you want to send another system generated consent collection reminder email and SMS to the candidate?',
    interviewReport: 'Interview Report',
    questions: 'Questions',
    clickToView: 'Click to view',
    aiInterviewTime: 'AI Interview Time',
    overallScore: 'Overall Score',
    copiedFrom: 'Copied from: ',
    rateDate: 'Invitation Time',
    screen: 'Screen',
    activityTracker: 'Activity',
    screening: 'Screening',
    collapseQuestion: 'Q',
    collapseAnswer: 'A',
    collapseVideo: 'V',
    collapseNote: 'N',
    elcQuestionQRCodeTip: 'Please scan below QR code to finish the open question(s) of this application, you may ask to log in with your current account.',
    partTimeExperience: 'Intern / Part time experience',
    workExperience: 'Work Experience',
    or: 'OR',
    thirdType: 'SIGN IN WITH:',
    experience: 'Work Experience',
    education: 'Education',
    importResumeTip: 'Import your resume from:',
    preferenceTip: 'Upload / submit your resume to get noticed by recruiters!',
    degreeLevel: 'Degree',
    to: 'to',
    hasDuplicateCandidate: 'The candidate you uploaded may be already existed in talent pool. Please contact responsible recruiter for more details. ',
    duplicateTalentCandidatePrevTip: 'Oops. This candidate already exists in the talent pool. ',
    duplicateTalentCandidateToView: 'Click here',
    duplicateTalentCandidateEndTip: ' to view.',
    countryCode: 'Country Code',
    aiQuestions: 'Questions:',
    answers: 'Answer:',
    interviewResult: 'Interview Result',
    ashbyCandidateProfileUrl: 'Ashby Profile URL',
    viewAshbyCandidateProfile: 'View',
    appliedJobsTotalLabel: 'Total applications: ',
    otherAppliedJobsLabel: 'Most recent applications: ',
    organizer: 'Organizer',
    interviewers: 'Interviewer(s)',
    applicationFormInvitationTime: 'Most Recent Invitation Time: ',
    applicationFormFinishedTime: 'Most Recent Completion Time: ',
    applicationFormStatus: 'Status: ',
    applicationFormCandidateName: 'Candidate Name: ',
    applicationFormDate: 'Date: '
  },
  placeholder: {
    professionalMemberShip: 'List any relevant professional organizations you are part of',
    awards: 'List any relevant awards you have received',
    hobbies: 'List any of your interests or hobbies you wish to share',
    uploadFileDescription: 'Description',
    keywordSearch: 'Keywords Search',
    allStatus: 'All Status',
    input: 'Input',
    select: 'Select',
    startDate: 'Start date',
    endDate: 'End date',
    selectDate: 'Please select a date',
    major: 'Major, start typing & select',
    school: 'School name, start typing & select',
    inputAndSelect: 'Click to start typing and select',
    videoDescription: 'Tap to add a note to your video file…',
    fileDescription: 'Tap to add a note to your portfolio file…',
    pleaseStartTyping: 'Please start typing',
    currentDate: 'Current'
  },
  btn: {
    reset: 'Reset',
    confirm: 'Confirm',
    addTag: 'Add Tag',
    personalStatementInfoDescription: 'In a few sentences please share what makes you unique or what makes you the best person for the job',
    expectedSalaryInfo: 'monthly after taxes in RMB',
    addChatTool: 'add another ID',
    addSocialNetwork: 'add another network',
    selectPhoto: 'Select File',
    upload: {
      selectFile: 'Select file',
      selectAnotherFile: 'Select another file'
    },
    viewDuplicateCandidate: 'View',
    addEducationBackground: 'Add education (From highest degree)',
    editor: 'Edit',
    delete: 'Delete',
    addLanguage: 'Add Languages',
    backJobList: 'View Job List',
    backApplicantList: 'Back To Applicant List',
    viewHistory: 'View Upload History',
    openUploader: 'Batch Upload Candidate',
    startUpload: 'Start Upload',
    viewCandidate: 'View Candidate',
    addPartTimeExperience: 'Add intern / part time experience',
    addWorkExperience: 'Add work experience',
    addComment: 'Comment',
    cancel: 'Cancel',
    reschedule: 'Reschedule',
    sendInterviewRating: 'Remind Hiring Manager to complete interview rating',
    viewGroupInterview: 'View Group Interview Details',
    more: 'More',
    scheduleAnotherInterview: 'Schedule Another Interview',
    interviewConfirm: 'Interview Confirm',
    inviteApplyJob: 'Invite to Apply Job',
    inviteFinishProfile: 'Invite to Finish Profile',
    exportPDF: 'Export as PDF',
    share: 'Share',
    contact: 'Contact',
    editResume: 'Edit',
    editOpenQuestion: 'Recruiter Screening Question(s)',
    copyCandidate: 'Copy',
    group: 'Group',
    inviteAnswerQuestion: 'Send screening questions to candidate',
    hiringManagerRating: 'Send profile to Hiring Manager for rating',
    hiringManagerInterview: 'Invite to Interview',
    startInterview: 'Interview Now',
    startRating: 'Rate Now',
    viewReport: 'View Report',
    inviteValueAndStrengthLabel: 'Invite to finish value & strengths',
    inviteProblemSolveLabel: 'Invite to finish problem solving',
    inviteOnboarding: 'Invite onboarding questionnaire',
    invitedAndResent: 'Invited on {date} (Resend)',
    invited: 'Invited at {date}',
    invitePostApplicant: 'Send portal invitation to candidate',
    inviteSatisfactionSurvey: 'Send satisfaction survey to candidate',
    addGroup: 'Add new...',
    moveGroup: 'Move to...',
    reject: 'Reject',
    moveForward: 'Move Forward',
    updateMobilePhone: 'Update Mobile',
    inviteNoFinishedOpenQuestion: 'No answer, send the invitation again',
    resume: 'Profile only',
    report: 'Report only',
    resumeAndReport: 'Profile and Report',
    exportConsentInfo: 'Consent Info',
    agencyUploadedCandidate: {
      accept: 'Accept',
      reject: 'Reject',
      rejected: 'Rejected'
    },
    exportConsentPDF: 'Export consent info as PDF',
    exportWord: 'Export as Word',
    inviteAnswerORQuestion: 'Invite OR questionnaire',
    revokeApplication: 'Delete This Application Record',
    revokeAllApplication: 'Delete Full Candidate Record',
    viewResume: 'View Original',
    viewProfile: 'View Profile',
    exportOriginResume: 'Export Original Resume',
    exportAjingaProfilePDF: 'Export AJINGA Profile PDF',
    inviteAgreeConsent: 'Send Consent Email and SMS',
    inviteAgreeConsentByLink: 'Copy Consent URL',
    inviteAgreeConsentQrCode: 'Generate Consent QR-code',
    inviteUploadResume: 'Refresh',
    confirmInviteUploadResumeContent: 'Send email to request your candidate to upload the latest version of their resume.',
    inviteUploadResumeResent: 'Invited on {date} (Re-invite to Upload Resume)',
    inviteUploadResumeUpdate: 'Resume Uploaded, Invite Again',
    inviteAiInterview: 'Invite to do AI interview',
    inviteAiInterviewResent: 'Invited on {date} (Re-invite to AI interview)',
    hasInviteAIInterview: 'Invited AI Interview on {date}',
    cancelSendInviteUpload: 'Back',
    confirmSendInviteUpload: 'Send',
    confirmInviteUploadResumeTip: 'Send email to request your candidate to upload the latest version of their resume.',
    createAISummary: 'Summarize Resume',
    viewAISummary: 'View/Edit AI Summary',
    aiResumeSummarizerCopy: 'Copy AI Resume Summary',
    createAIResumeMatch: 'AI Fit Score',
    resendHmRating: 'Resend profile to Hiring Manager for rating',
    inviteJobApplication: 'Invite Job Application',
    remindJobApplication: 'Send Reminder',
    resendJobApplication: 'Invited on {time}',
    reactivatedJobApplication: 'Reactivated on {time}',
    backToResume: 'Back to Resume',
    downloadJobApplicationPDF: 'Download PDF',
    reactivateJobApplication: 'Reactivate',
    save: 'Save',
    createNewResume: 'Create New Resume',
    ios: 'iOS / iCloud',
    android: 'Android',
    harmony: 'Harmony',
    photo: 'Photo',
    uploadResume: 'Upload My Resume',
    importJob51: 'Import 51job.com Resume',
    importJobStreet: 'Import JobStreet.com Resume',
    job51: '51job.com',
    jobStreet: 'Jobstreet.com',
    editProfile: 'Use my Existing Resume',
    clear: 'Clear',
    sendOfferLetter: 'Send Offer',
    sendOfferLetterNotice: 'Send Reminder',
    resendOfferLetterNotice: 'Send Reminder',
    reSendInviteOfferLetter: 'Re-Offer',
    exportOfferPdf: 'Export',
    sendOffer: 'Send',
    inviteAIInterview: 'Invite AI Interview',
    skip: 'Skip',
    summaryViewResume: 'View Resume',
    sendAIInterviewReminder: 'Send AI Interview Reminder'
  },
  message: {
    refreshPageWithoutSaveData: 'Please click OK to leave the page (any data you have entered will be lost).\nPlease click CANCEL to stay on this page.',
    select: 'Select',
    wrongPhotoFileType: 'Please make sure image type is jpeg or jpg or png',
    startDateAfterEndDate: 'End dates should be later than start dates.',
    gpaDataValueError: 'The GPA should be greater than or equal to 0 and less than or equal to 4.',
    questionVideoIsTooLong: 'Video is more {duration}',
    requiredQuestionAnswer: 'This is a required question, please choose or input your answer',
    wrongFileType: 'Please check the type of choose file',
    wrongFileSize: 'Please check the size of choose file',
    uploadTip: {
      waitUploaded: 'Please wait file uploaded',
      openQuestionVideo: 'Make sure your video is less than {duration}. You may upload MP4, mov, ogg and avi file types.',
      attachment: 'Click the icon to upload your attachment. Files may be up to {size}MB in size. Please be aware the upload may take 4-6mins to complete, depending on your internet connection.',
      videoUploadTips: 'Tap to record and upload your video NOW, or you can \'FAVORITE\' this page to navigate back here LATER when you have finished recording your video.',
      videoUploadTipsPC: 'Tap to upload your video NOW, or you can \'FAVORITE\' this page to navigate back here LATER when you have finished recording your video.',
      videoUploadTipsForELC: 'Tap to record your video NOW, or you can \'FAVORITE\' this page to navigate back here LATER when you are ready.'
    },
    sourceTips: 'Not all users have the authority to create their own source name. If you don’t see your source name in the drop-down list and are unable to create a new source name, please contact your company AJINGA administrator or email service@ajinga.com.',
    sourcePlaceholder: 'e.g. Job Fair or Hiring Campaign etc.',
    codeTips: 'Not all users have the authority to create their own Source Tag / Detail. If you don’t see your Source Tag / Detail in the drop-down list and are unable to create a new one, please contact your company AJINGA administrator or email service@ajinga.com.',
    codePlaceholder: 'e.g. Job Fair Date, Campaign Name etc.',
    needOneOfEmailOrMobile: 'Please enter either email or mobile of the candidate.',
    isHrEmailOrPhone: 'The account cannot be uploaded as it belongs to a company user. Please contact service@ajinga.com for further support.',
    hasUploadedInTalentPool: 'Oops! You cannot upload this candidate. A candidate with this email and/or mobile phone number, already exists in the talent pool.',

    educationRequired: 'Please select education level',
    majorRequired: 'Please select major',
    startTimeRequired: 'Please select start time',
    endDateRequired: 'Please select end date (expected graduation date)',
    schoolRequired: 'Please select school',
    educationCountRequired: 'At least one educational experience.',

    dropTip: 'Drag and drop resume here',
    or: 'Or',
    uploadTips: [
      'You can only upload a resume no more than 10MB',
      "The acceptable file types include 'pdf', 'doc', 'docx, 'shtml', 'html', 'png', 'jpg', 'jpeg' and 'bmp' formats"
    ],
    noSelectedFile: 'no selected any file yet',
    uploadingTip: 'File is uploading, does not close this page',
    uploadedTip: 'File is uploaded, you can close this page safely. Resume will be start process',
    noUploadingFile: 'no any file is uploading',
    leavePageTip: 'Confirm leave this page? File is still uploading!',
    fileCountLimit: 'Only can add {count} files in single upload task',
    fileSizeLimit: 'Single File except size is {size}MB',
    uploadFinished: 'Upload Finished',
    companyNameRequired: 'Please Input Company Name',
    jobTitleRequired: 'Please Input Job Title',
    industryRequired: 'Please Select Industry',
    jobFamilyRequired: 'Please Select Job Family',
    countryRequired: 'Please Select Country / Region',
    provinceRequired: 'Please Select Province / State',
    cityRequired: 'Please Select City / Town',
    startDateRequired: 'Please Select Start Date',
    workCountRequired: 'At least one work experience experience.',
    internCountRequired: 'At least one work intern experience.',
    saveQuestionSuccess: 'Save Success',
    addCommentSuccess: 'Add Success',
    addCommentFail: 'Add Comment Failed',
    inviteFinishProfile: {
      success: 'Invite Success',
      noEmailAccount: 'This candidate do not have an email address, we cannot invite this candidate currently. Our SMS invitation is under developing. Coming SOON!',
      hasFinished: 'This candidate has completed the resume and does not need to be invited',
      fail: 'Invite Failed'
    },
    inviteFinishAssessment: {
      success: 'Invite Success',
      noEmailAccount: 'This candidate do not have an email address, we cannot invite this candidate currently. Our SMS invitation is under developing. Coming SOON!',
      hasFinished: 'This candidate has completed the assessment and does not need to be invited',
      fail: 'Invite Failed'
    },
    emailHasAlreadyUsed: 'The email address has been used, please change it!',
    fieldRequired: 'Please expand and complete items in red.',
    cannotCancelInterviewDueToDeadline: 'Your invitation(s) cannot be canceled as the scheduled interview time has already passed.',
    cannotCancelInterviewHasBeenRated: 'Your invitation(s) cannot be canceled as other hiring managers have already submitted their ratings.',
    confirmToCancelInterview: 'Are you sure you want to cancel this interview?',
    inviteORQuestion: 'Of the {inviteCount} people you selected to send this invitation, {successCount} have successfully been sent your invitation.',
    revokeApplicationConfirmTip: 'Confirm to delete this candidate\'s application?',
    revokeAllApplicationConfirmTip: 'Confirm to delete ALL this candidate\'s data?',
    headhunterUploadSuccess: 'Candidate resume is successfully uploaded. Please remind candidate to check the auto Email from the system and accept your consent. Your referral will be completed with the consent of referee. Thank you for your support!',
    noData: 'No more data',
    inviteAgreeConsent: {
      success: 'Email and SMS sent successfully.',
      copySuccess: 'URL copied successfully. You can now share with your candidate.'
    },
    uploadResumeTips: 'job requires uploading a resume',
    cannotCancelMicrosoftMeeting: 'The meeting in this interview record needs to be logged into a Microsoft account before the interview can be cancelled',
    cvOwner: 'Owner: {name}',
    inviteCandidateUploadSuccess: 'Invite Success',
    aiSummaryCopySuccess: 'Copied Success',
    addToGenerateTaskSuccessful: 'Please give us a moment to process the fit score. Thank you!',
    beforeData: 'This date must before {beforeDate}',
    afterDate: 'This date must after {afterDate}',
    resetEndDate: 'End date must be after this date',
    pendingUpload: 'Pending upload',
    endDate: 'Current',
    uploadSuccess: 'Upload successfully',
    processQuestionAnswer: 'Calculating, please check later',
    uploadVideoSuccess: 'Upload Success',
    uploadVideoFail: 'Upload Fail, please try again later!',
    canNotInviteSatisfactionSurvey: 'Oops, it seems you cannot send the satisfaction survey to this candidate because this candidate has not yet consented to the privacy policy.',
    sendOfferNoticeSuccess: 'Successfully Sent',
    inviteOfferSuccess: 'Invite Successful',
    reInviteOfferSuccess: 'Re-Offer Successfully Sent',
    hasDuplicateCandidate: 'The candidate you uploaded may be already existed in talent pool. Please contact responsible recruiter for more details.',
    deleteSuccess: 'Successfully deleted.',
    disabledTip: 'You do not have the authority to manage the candidates in this job.',
    remindJobApplicationSuccess: 'Reminder sent',
    reactivateTitle: 'Confirm Reactivation',
    reactivateReasonLabel: 'Reactivation Reason (Optional)',
    reactivateReason: 'Enter reactivation reason (optional)',
    reactivateSuccess: 'Reactivated successfully',
    reactivateFailed: 'Failed to reactivate',
    jobAIInterviewRoomError: 'Job need a interview room',
    jobAIInterviewRoomErrorContent: "Click 'Select' to create an interview room",
    inviteAIInterviewSuccess: 'Invite Successful',
    sendAIInterviewReminderSuccess: 'Sent Successfully',
    aiParseResumeError: 'AI analysis of the resume is abnormal. Please try again later',
    parseResumeError: 'Analysis of the resume is abnormal. Please try again later',
    aiParseResumeTimeout: 'AI analysis of the resume has timed out. Please try again later'
  },
  questionType: {
    TEXT: 'text',
    TEXTAREA: 'text',
    SELECT: 'single',
    RADIO: 'single',
    CHECKBOX: 'multiple',
    DATE: 'date',
    VIDEO: 'video',
    ATTACHMENT: 'attachment',
    POLICY: 'policy'
  },
  fileUpload: {
    empty: 'Pending for uploading',
    uploading: 'Uploading',
    uploaded: 'Uploaded'
  },
  editor: {
    addChatTool: 'Add another ID',
    deleteChatTool: 'Delete this another ID',
    addSocialNetwork: 'Add another network',
    deleteSocialNetwork: 'Delete this another network',
    education: {
      title: {
        addEducation: 'Add education',
        deleteEducation: 'Delete this education',
        editEducation: 'Edit Education'
      },
      message: {
        schoolRequired: 'Please select school',
        educationRequired: 'Please select education level',
        educationCountRequired: 'At least one educational experience.'
      }
    },
    language: {
      title: {
        addLanguages: 'Add languages',
        deleteLanguages: 'Delete this languages',
        editorLanguages: 'Edit Languages'
      }
    },
    workExperience: {
      title: {
        addWorkExperience: 'Add work experience',
        deleteWorkExperience: 'Delete this work experience',
        editorWorkExperience: 'Edit Work Experience'
      }
    },
    partTimeExperience: {
      title: {
        addWorkExperience: 'Add intern / part time experience',
        deleteWorkExperience: 'Delete this intern / part time experience',
        editorWorkExperience: 'Edit Intern / Part Time Experience'
      }
    }
  },
  tip: {
    uploadVideo: 'Tap to upload your video NOW',
    uploadVideoInfo: "OR You can 'FAVORITE' this page to navigate back here LATER when you have finished recording your video.Make sure your video is LESS than 30s.You may upload MP4, mov, ogg and avi file types.",
    uploadAttachment: 'Click the icon to upload your attachment',
    uploadAttachmentInfo: 'Files may be up to 200MB in size. Please be aware the upload may take 4-6mins to complete, depending on your internet connection.',
    resumeFitInfo: 'The AJINGA AI powered Resume Fit score is calculated by comparing the language of the job description with the candidate\'s working experience in the resume. The AI can manage English-English or Chinese-Chinese comparisons only. This feature is currently in BETA version. We welcome your feedback and encourage you to contact your AJINGA success consultant, with questions or improvement suggestions.'
  },
  openQuestionContainerType: {
    PRESCREEN: 'Applicant Prescreen Section Questionnaire',
    NORMAL: 'Applicant Questionnaire',
    SPECIFIC: 'Specific Questions',
    HR: 'Recruiter Screen'
  },
  containerTitle: {
    uploadHistory: 'Upload History',
    selectedFiles: 'Selected Files',
    uploadStatus: 'Upload Status'
  },
  taskStatus: {
    FAILED: 'Failed',
    FINISHED: 'Success',
    APPLICATION_EXISTED: 'Re-addition',
    WAITING: 'Processing',
    UPLOADING: 'Uploading'
  },
  jobApplicationPlat: {
    emailResume: {
      'www.51job.com': '51job.com',
      'www.zhaopin.com': 'Zhaopin.com',
      'www.58.com': '58.com',
      'www.61hr.com': '61HR.com',
      'www.veryeast.cn': 'VeryEast.com',
      'www.ganji.com': 'Ganji.com',
      'www.linkedin.com': 'LinkedIn.com',
      'www.liepin.com': 'Liepin.com',
      'www.wotui.com': 'Wotui.com',
      'gikoo.cn': 'Gikoo.cn',
      'yingjiesheng.com': 'Yingjiesheng.com',
      'shixiseng.com': 'Shixiseng.com',
      'www.jobsdb.com': 'JobsDB',
      'JobStreet.com': 'JobStreet.com',
      'jianzhimao.com': 'jianzhimao.com',
      Others: 'AJINGA'
    },
    candidateUpload: 'Vendor Resume Upload',
    uploadByAgency: 'Uploaded by agency',
    aspireProgram: 'Aspire Program',
    submittedReferral: 'Submitted referral',
    workday: 'Workday',
    ajinga: 'AJINGA'
  },
  ACADEMIC_RATING: {
    TOP5: 'Top 5%',
    TOP10: 'Top 10%',
    TOP20: 'Top 20%',
    TOP30: 'Top 30%',
    OTHER: 'Other'
  },
  STATUS_GROUP: {
    APPLY: 'Source',
    SCREEN: 'Screen',
    INTERVIEW: 'Interview',
    OFFER: 'Offer',
    HIRED: 'Hired'
  },
  consentStatusType: {
    Agreed: 'Agreed',
    Rejected: 'Rejected',
    Pending: 'Pending'
  },
  AI_PARSE_TASK_STATUS: {
    START: 'AJINGA Smart AI is parsing your uploaded resume file.',
    REVIEW: 'AJINGA Smart AI is reviewing your resume file...',
    READING: 'AJINGA Smart AI is reading your resume file...',
    EXTRACTION: 'AJINGA Smart AI is extracting your resume file information...',
    FORMATING: 'AJINGA Intelligent AI is formatting extracting information...',
    WRITING: 'AJINGA Smart AI is about to finish parsing your resume file...'
  }
}
